
import { defineComponent } from 'vue';
import Overlay from '@/components/Overlay.vue';

export default defineComponent({
  name: 'DashboardCard',

  components: {
    Overlay,
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    totalValue: {
      type: [Number, String],
      default: 0,
    },

    size: {
      type: [String],
      default: '',
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    return {};
  },
});
